import type en from '@/messages/en.json'

export type Locale = 'en' | 'ar' | 'fr' | 'hi'

export type Messages = typeof en

export interface I18nContextValue {
  locale: Locale
  setLocale: (locale: Locale) => void
  t: (key: string, params?: Record<string, string | number>) => string
}

export const LOCALE_STORAGE_KEY = 'hf-locale'

export const RTL_LOCALES: Locale[] = ['ar']

export const LOCALE_LABELS: Record<Locale, string> = {
  en: 'English',
  ar: 'العربية',
  fr: 'Français',
  hi: 'हिन्दी',
}
